<script>
  import { portal } from "svelte-portal";
  import { fade, scale } from "svelte/transition";

  const HTML_CLASS_LIST = document.documentElement.classList;
  const OVERFLOW_CLASS = "overflow-hidden";
  const OVERLAY_CLASS = "has-overlay";

  export let showModal = false;

  $: if (showModal) {
    HTML_CLASS_LIST.add(OVERFLOW_CLASS, OVERLAY_CLASS);
  } else {
    HTML_CLASS_LIST.remove(OVERFLOW_CLASS, OVERLAY_CLASS);
  }
</script>

<svelte:window
  on:openLogin={() => {
    showModal = true;
  }}
  on:keyup={(event) => {
    if (event.key === "Escape") {
      showModal = false;
    }
  }}
/>

{#if showModal}
  <div transition:fade={{ duration: 200 }} use:portal={"body"} aria-hidden="true" class="fixed inset-0 z-60 bg-black/80 backdrop-blur supports-[backdrop-filter]:bg-black/75" />
  <div transition:fade={{ duration: 200 }} use:portal={"body"} role="dialog" aria-modal="true" class="fixed inset-0 z-70 grid grid-rows-[minmax(0,1fr)_auto_minmax(0,1fr)] overflow-auto">
    <button
      title="Schließen"
      type="button"
      class="fixed right-4 top-4 text-5xl text-theme-minor-50 opacity-80 hocus:opacity-100"
      on:click={() => {
        showModal = false;
      }}>&times;</button
    >
    <div transition:scale={{ duration: 200 }} class="row-start-2 flex items-center justify-center">
      <section class="text- relative mx-4 my-12 w-full max-w-2xl bg-white p-10 sm:mx-6 lg:mx-8">
        <slot />
      </section>
    </div>
  </div>
{/if}
